import { render, staticRenderFns } from "./AppDocumentos.vue?vue&type=template&id=21734b6e&scoped=true&lang=pug&"
import script from "./AppDocumentos.vue?vue&type=script&lang=js&"
export * from "./AppDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./AppDocumentos.vue?vue&type=style&index=0&id=21734b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21734b6e",
  null
  
)

export default component.exports